module.exports = __webpack_public_path__ + "img/eze.78b1f1ea.jpeg";